import React from "react";
import Link from "gatsby-link";
import PostTags from "../Linking/postTags";

const PostIntro = ({ post }) => (
  <article>
    <Link to={post.frontmatter.path}>
      <h2>{post.frontmatter.title}</h2>
    </Link>
    <p>{post.excerpt}</p>
 
     <PostTags list={post.frontmatter.tags}></PostTags>
  </article>
);

export default PostIntro;


// WEBPACK FOOTER //
// ./src/components/Linking/postIntro.js